import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_SALES_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { SALES_SIGNUP } from '../constants/signupConstants';
import { EXPERIENCE_NONE_PARAM, SALES_REP_ROLE, EMPLOYEE_MANAGEMENT_LEVEL, STUDENT_INTERN_MANAGEMENT_LEVEL, FREELANCER_MANAGEMENT_LEVEL } from '../constants/surveyConstants';
import { HubletUrl } from '../utils/urls';
import { ONBU025_EXPERIMENT_KEY, ONBU025_VARIANT_GROUP } from '../constants/experimentConstants';
const salesExperiencesChecks = [{
  // Note: ONBU025 variant users see the same experience except with the variant groupkeys
  // The only change in these groupkeys is that the 'create contact' and 'create deal' tasks go to the corresponding wizard instead of a tour
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-ic`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      // These management levels / job titles are analogous to a Sales Rep or Sales IC
      jobTitle: [EMPLOYEE_MANAGEMENT_LEVEL, STUDENT_INTERN_MANAGEMENT_LEVEL, FREELANCER_MANAGEMENT_LEVEL]
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-ic`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      // These management levels / job titles are analogous to a Sales Rep or Sales IC
      jobTitle: [EMPLOYEE_MANAGEMENT_LEVEL, STUDENT_INTERN_MANAGEMENT_LEVEL, FREELANCER_MANAGEMENT_LEVEL]
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-ic`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      jobRole: SALES_REP_ROLE
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-ic`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      jobRole: SALES_REP_ROLE
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-leader`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-leader`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesViewWizard
    };
  },
  checks: [{
    signupExperimentTreatments: {
      [ONBU025_EXPERIMENT_KEY]: ONBU025_VARIANT_GROUP
    },
    signupType: SALES_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP
  }]
}];
export default salesExperiencesChecks;